import { HStack, VStack, XText } from "IZOX/_X";
import { OperBar, QForm } from "IZOX/BLOCKS/Libs";
import QFQUICK from "IZOX/BLOCKS/Libs/QForm/QFQUICK";
import { ColorX, LocaleX } from "IZOX/STATIC";
import { useState } from "react";

function RenameFilePopup({
  defaultName,
  onRenameFile,
  onCancel
}){

  const [form, setForm] = useState({
    folderName: ""
  });

  return (
    <VStack width={350} bgColor={ColorX.CSS("pureWhite")} round={10} spacing={10} pT={5}>
      <HStack>
        <XText bold fontSize={16}>
          {LocaleX.Parse({
            EN: "Rename File",
            TC: "重新命名檔案"
          })}
        </XText>
      </HStack>
      <QForm onChange={setForm} value={form} p={5} >
        {QFQUICK.TextField({
          EN: "New File Name",
          TC: "新檔案名稱",
        }, "fileName", {labelWidth: 120}, {
          defaultValue: defaultName,
          placeholder: {
            EN: "Enter file name",
            TC: "輸入檔案名稱"
          }})}
      </QForm>
      <OperBar onConfirm={() => onRenameFile(form.fileName)} 
        onCancel={onCancel}/>
    </VStack>
  );
}

export default RenameFilePopup;